<template>
  <v-list-item :to="to" class="v-list-item--doc" color="primary" ripple>
    <v-list-item-icon v-if="icon">
      <v-icon v-text="icon" />
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        <span v-text="text" />
      </v-list-item-title>
    </v-list-item-content>
    <slot />
  </v-list-item>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: [Boolean, String],
      default: false,
    },
    to: {
      type: Object,
    },
    permissions: {
      type: Array,
    },
  },
};
</script>

<style scoped>
>>> .v-list-item--doc p {
  margin-bottom: 0;
}
</style>
